import { useTranslation } from 'react-i18next'
import { Anchor, Box, Group, Image, Text, useMantineColorScheme } from '@mantine/core'

export default function AgFooter() {
  const { t, i18n } = useTranslation()
  const { colorScheme } = useMantineColorScheme()
  const isDark = colorScheme === 'dark'

  const lang = i18n.resolvedLanguage || i18n.language || 'es'
  const isEn = String(lang).toLowerCase().startsWith('en')

  const privacyUrl = isEn
    ? 'https://agforest.ai/en/privacy-and-cookies-policy'
    : 'https://agforest.ai/politica-de-privacidad-y-cookies'

  const legalUrl = isEn ? 'https://agforest.ai/en/legal-notice' : 'https://agforest.ai/aviso-legal'

  const accentColor = isDark ? '#00ff00' : '#00aa00'
  const textColor = isDark ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)'
  const borderColor = isDark ? 'rgba(0, 255, 0, 0.2)' : 'rgba(0, 100, 0, 0.12)'

  return (
    <Box
      component="footer"
      px="lg"
      py="sm"
      style={{
        background: isDark ? 'rgba(0, 0, 0, 0.85)' : 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(12px)',
        borderTop: `1px solid ${borderColor}`,
      }}
    >
      <Group justify="space-between" align="center">
        <Text size="sm" c={textColor}>
          © {new Date().getFullYear()} AGForest
        </Text>

        <Group gap="xs">
          <Anchor
            href={privacyUrl}
            target="_blank"
            rel="noopener noreferrer"
            size="sm"
            style={{
              color: textColor,
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = accentColor)}
            onMouseLeave={(e) => (e.currentTarget.style.color = textColor)}
          >
            {t('footer.privacy')}
          </Anchor>
          <Text size="sm" c={isDark ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)'}>
            |
          </Text>
          <Anchor
            href={legalUrl}
            target="_blank"
            rel="noopener noreferrer"
            size="sm"
            style={{
              color: textColor,
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = accentColor)}
            onMouseLeave={(e) => (e.currentTarget.style.color = textColor)}
          >
            {t('footer.legal')}
          </Anchor>
        </Group>

        <Group gap="md">
          <Image
            src="/union_europea.webp"
            alt={t('footer.euAlt')}
            h={40}
            style={{ opacity: isDark ? 0.8 : 1 }}
          />
        </Group>
      </Group>
    </Box>
  )
}
